import React, { useEffect, useState } from "react";

export default function OfflineBanner({ message }) {
  const [offline, setOffline] = useState(!navigator.onLine);
  useEffect(() => {
    const off = () => setOffline(true);
    const on = () => setOffline(false);
    window.addEventListener("offline", off);
    window.addEventListener("online", on);
    return () => {
      window.removeEventListener("offline", off);
      window.removeEventListener("online", on);
    };
  }, []);
  if (!offline) return null;
  return (
    <div className="offline-banner" data-testid="offline-banner" role="alert">
      {message}
    </div>
  );
}
